module.exports = __webpack_public_path__ + "img/screens-insanon.3110aee9.png";